import styled from "styled-components";

export const ParagraphSmall = styled.p`
  font-size: var(--font-size-20);
  line-height: var(--line-height-20);
  color: var(--color-neutral-50);
`;
